import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["invalid", "success", "absolute", "children", "classes", "namespace"];
import React from 'react';
import classNames from 'classnames/bind';
import { defaultPropObject } from "../../../constants";
import { getMethodsForTestId } from "../../../utils/getMethodsForTestId";
import { TextBase } from '../../TextBase';
import styles from './FieldTooltip.css';
var cx = classNames.bind(styles);
export var FieldTooltip = function FieldTooltip(_ref) {
  var invalid = _ref.invalid,
      success = _ref.success,
      absolute = _ref.absolute,
      children = _ref.children,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes,
      namespace = _ref.namespace,
      props = _objectWithoutProperties(_ref, _excluded);

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'fieldTooltip'),
      getTestId = _getMethodsForTestId.getTestId,
      getNamespace = _getMethodsForTestId.getNamespace;

  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: cx('root', {
      invalid: invalid,
      success: success,
      absolute: absolute
    }, classes.root)
  }, getTestId()), /*#__PURE__*/React.createElement(TextBase, {
    size: "s",
    color: "inherit",
    namespace: getNamespace()
  }, children));
};